import React from "react";
import { Typography, Container } from "@mui/material";

const Diagnostics = () => { 
  return (
    <Container sx={{ py: 5 }}>
      <Typography variant="h4" gutterBottom sx={{ color: '#ED1C24' }}>
        Diagnostics Care
      </Typography>
      <Typography variant="body1" paragraph>
        Our Diagnostics Care services are designed to provide accurate, reliable, and timely medical 
        investigations to support effective treatment. With state of the art equipment and skilled 
        technicians, we ensure that every diagnostic test is conducted with precision and patient comfort 
        in mind.
      </Typography>
      
      <Typography variant="body1" paragraph>
        <strong>ECG (Electrocardiogram):</strong> Records the heart’s electrical activity to detect 
        irregularities, heart blockages, or other cardiac conditions.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>USG (Ultrasonography):</strong> A safe, non invasive imaging technique for examining organs, 
        tissues, and monitoring pregnancies.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>X-ray Imaging:</strong> Helps in identifying bone fractures, lung infections, and other 
        internal conditions with minimal radiation exposure.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>CT (Computed Tomography) Scan:</strong> Produces detailed cross sectional images of the body 
        to assist in detecting tumors, injuries, and internal bleeding.
      </Typography>
      <Typography variant="body1" paragraph>
        <strong>MRI (Magnetic Resonance Imaging):</strong> Provides high clarity images of soft tissues, 
        brain, spine, joints, and other internal structures without radiation.
      </Typography>
      
      <Typography variant="body1" paragraph>
        In addition to these, we also offer laboratory tests, blood investigations, urine analysis, and 
        preventive health check-up packages, ensuring a comprehensive approach to diagnosis.
      </Typography>
      <Typography variant="body1" paragraph>
        Our goal is to deliver accurate reports quickly, enabling doctors and patients to make informed 
        healthcare decisions with confidence.
      </Typography>
    </Container>
  );
};


export default Diagnostics;
